import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';

import { IGroupItem } from 'sections/Feedback/EventsSurvey/types';

import { QuestionItem } from 'sections/Feedback/EventsSurvey/components/QuestionItem';

import styles from 'sections/Feedback/EventsSurvey/components/GroupItem/GroupItem.module.scss';

const cn = classNames.bind(styles);

const GroupItem: FC<IGroupItem> = ({
  formData,
  onChangeHandler,
  onBlurHandler,
  setFormData,
  dataQuestions,
  dataGroup,
  errorsAnswer,
}): ReactElement => {
  const { name, id } = dataGroup;

  return (
    <>
      <div className={cn('group-item')}>
        <h2 className={cn('group-item__heading')}>
          {name}
        </h2>
        <div className={cn('group-item__questions-container')}>
          {dataQuestions.map((item) => {
            if (item.tag_id === id) {
              return (
                <QuestionItem
                  key={item.id}
                  onChangeHandler={onChangeHandler}
                  onBlurHandler={onBlurHandler}
                  setFormData={setFormData}
                  question={item}
                  formData={formData}
                  errorsAnswer={errorsAnswer}
                />
              );
            }
          })}
        </div>
      </div>
    </>
  );
};

export { GroupItem };
